import React from 'react'
import './experience.css'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Tilt from 'react-tilt'
import Card from "react-bootstrap/Card";
import L_ACCENTURE from "../../assets/img/experience/accenture-3.svg";
import Container from "react-bootstrap/Container";

const Experience = () => {
    return (
        <div id="experience">
      <h1 className="pt-3 text-center font-details-b pb-3">EXPERIENCE</h1>
      <Jumbotron className="jumbo-style">
        <Container>
          <Tilt options={{ max: 25 }}>
            <Card>
              <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                <Card.Img variant="top" className="img-resize" src={L_ACCENTURE} alt="Accenture logo" />
              </Card.Header>
              <Card.Body className="d-flex justify-content-center flex-column">
                <div>
                  <Card.Title className="text-center">Freelance Web Developer</Card.Title>
                </div>
                <div>
                  <Card.Text className="text-center style">
                    <strong className="body-title-style ">Full Stack Developer</strong>
                    <br />
                    <strong>Technology:</strong> React JS, Django, Wordpress, MYSQL, Python
                    <br />
                    <strong>Duration:</strong> MAY 2020 - Present
                    <br/>
                    <strong> Description </strong>
                    <ul className="text-left">
                      <li><strong>Developed &amp; enhanced</strong> multiple features with customizability option across web application.</li>
                      <li><strong>Developed</strong> Ahmed is a certified web developer with skills in python, React and WordPress. He has developed projects in python Django like Ecommerce store, portfolio design and web scrapping application.
                      He has designed Shopify and Woo-commerce stores for clients in my remote job. Following are his skills that he is currently working on:
                      HTML, CSS, Bootstrap
                      React Javascript Development
                      Python Django framework
                      Shopify, woo-commerce store
                      Wordpress website design.
                      Ahmed is ambitious and diligent to work under the tight schedule and assure to give 100% quality work right on time.Best Regards.
                      </li>
                      <li><strong>Projects</strong> Made numerous applications like Covid-19 Tracker, Weather application, ecommerce stores, 
                      AirBnB clone, Netflix clone, Static and Dynamic web pages and built websites using WIX and Wordpress</li>
                      {/* <li><strong>Co-created</strong> React Document used as a guide for new developers.</li> */}

                    </ul>
                    
                    
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Tilt>
        </Container>
      </Jumbotron>
    </div>
    )
}

export default Experience
